import React, { useState } from 'react';
import { get, debounce, isEmpty } from 'lodash';
import axios from 'axios';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { API_HOST, TIPOS_ITENS } from '../../consts';
import { BaseForm } from '../../base';
import Loading from '../../components/Loading';
import RawInputSummernote from '../../components/inputs/RawInputSummernote';
import InputFile from '../../components/inputs/InputFile';
import FormContainer from '../../containers/Form';
import PreviewEscalaLinear from '../../components/PreviewEscalaLinear';
import GradeLinearMultipla from '../../components/GradeLinearMultipla';
import swal from 'sweetalert2';
import GeoGebra from 'react-geogebra';
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

let timer = null;

class Conteudo extends BaseForm {
  constructor(props) {
    super(props);
    this.onItemChange = this.onItemChange.bind(this);
    this.onAlternativaChange = this.onAlternativaChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.fetchAlternativas = this.fetchAlternativas.bind(this);
    this.patchAlternativa = this.patchAlternativa.bind(this);
    this.fetchGradeLinear = this.fetchGradeLinear.bind(this);
    this.onGradeLinearChange = this.onGradeLinearChange.bind(this);
    this.onGradeLinearMultiplaChange =
      this.onGradeLinearMultiplaChange.bind(this);
    this.onGradeLinearMultiplaExclude =
      this.onGradeLinearMultiplaExclude.bind(this);
    this.uploadArquivo = this.uploadArquivo.bind(this);
    this.uploadArquivoAlternativa = this.uploadArquivoAlternativa.bind(this);
    this.removeArquivo = this.removeArquivo.bind(this);
    this.removeArquivoAlternativa = this.removeArquivoAlternativa.bind(this);
    this.debouncedPatchAlternativa = [];
  }

  state = {
    collapse: {},
    alternativas: [],
    errors: [],
    fetchingData: true,
    arquivos: [],
    save: {},
    progressEvent: {},
    modalConfirmAlternativeRemoval: false,
    selectedAlternative: null,
    videoInputShouldDisplay: false,
    grade_linear: {},
    checkboxSelected: false,
    isGraphOpen: false,
    add_rubica: false,
    remove_rubica: false,
    valorRubrica: 0,
    descricaoRubrica: '',
    rubricas: [],
    selectedRubrica: null
  };

  toggle(index) {
    const collapse = [...this.state.collapse];
    collapse[index] = !collapse[index];
    this.setState({ collapse });
  }

  getAngleIcon(index) {
    if (this.state.collapse[index]) {
      return 'angle-down';
    }

    return 'angle-right';
  }

  componentDidMount() {
    if (this.id !== 'new') {
      this.fetchArquivos();
      this.fetchMetadata();

      Promise.all([
        this.fetchRubricas(),
        this.fetchItem(),
        this.fetchAlternativas(),
        this.fetchGradeLinear()
      ]).then(() => this.setState({ fetchingData: false }));
    }
  }

  fetchItem() {
    return axios
      .get(`${API_HOST}/itens/item/${this.id}/form`)
      .then((response) => {
        const { tipo, ...leftover } = response.data;

        let type_response = ['situacao_problema', 'comando_resposta'];

        if (
          [
            TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA,
            TIPOS_ITENS.LACUNA
          ].includes(tipo)
        ) {
          type_response = [
            'situacao_problema',
            'comando_resposta',
            'expectativa_resposta',
            'orientacao_correcao',
            'min_palavras',
            'max_palavras',
            'min_caracteres',
            'max_caracteres',
            'numero_respostas'
          ];
        } else if (tipo === TIPOS_ITENS.DISCURSIVO) {
          type_response = [
            'situacao_problema',
            'comando_resposta',
            'expectativa_resposta',
            'orientacao_correcao',
            'min_palavras',
            'max_palavras',
            'min_caracteres',
            'max_caracteres'
          ];
        }
        else if (tipo === TIPOS_ITENS.DISCURSIVO_COM_RUBICAS) {
          type_response = [
            'situacao_problema',
            'comando_resposta',
            'expectativa_resposta',
            'orientacao_correcao',
            'min_palavras',
            'max_palavras',
            'min_caracteres',
            'max_caracteres'
          ];
        }
        this.fields = type_response;

        const values = this.getValues(leftover);
        this.setState({ ...values, tipo });
      });
  }

  fetchRubricas() {
    return axios
      .get(`${API_HOST}/itens/discursivo_rubrica/${this.id}/get_rubrica`)
      .then((response => {
        this.setState({ rubricas: response.data })

      }))
  }

  fetchArquivos() {
    return axios
      .get(`${API_HOST}/itens/item/${this.id}/arquivos`)
      .then((response) => {
        this.setState({
          arquivos: response.data,
          uploading: false
        });
      });
  }

  fetchMetadata() {
    axios
      .get(`${API_HOST}/params/param?model=item|alternativa`)
      .then((response) => {
        this.setState({ metadata: this.mapMetadata(response.data) });
      });
  }

  patchAlternativa(data, fetchAgain = false) {
    const { save } = this.state;
    save[data.id] = this.SALVANDO;
    this.setState({ save });

    axios.patch(`${API_HOST}/itens/alternativa/${data.id}`, data).then(() => {
      const { save } = this.state;
      save[data.id] = this.SALVO;
      this.setState({ save });

      if (fetchAgain) {
        this.fetchAlternativas();
      }

      // if (atualizarDistratores) {
      //   const { alternativas } = this.state;
      //   alternativas.forEach((alternativa) => {
      //     if (alternativa.id !== data.id) {
      //       alternativa.gabarito = false;
      //     }
      //   });
      //   this.setState({ alternativas });
      // }
    });
  }

  fetchAlternativas() {
    return axios
      .get(`${API_HOST}/itens/alternativa`, {
        params: {
          item: this.id
        }
      })
      .then((response) => {
        const save = {};
        response.data.forEach(({ id }) => {
          save[id] = this.ATUALIZADO;
        });
        save.item = this.ATUALIZADO;

        this.setState({ save, alternativas: response.data });

        this.debouncedPatchAlternativa = response.data.map(() =>
          debounce(this.patchAlternativa, 1000)
        );
      });
  }

  fetchGradeLinear() {
    return axios.get(`${API_HOST}/itens/item/${this.id}`).then((response) => {
      const jsonResponse = response.data.grade_linear;

      let grade_linear = {};

      if (jsonResponse) {
        grade_linear = JSON.parse(jsonResponse.replace(/'/g, '"'));
      }

      if (grade_linear && grade_linear.column) {
        this.setState({ column: grade_linear.column });
      }

      if (grade_linear && grade_linear.row) {
        this.setState({ row: grade_linear.row });
      }

      this.setState({ grade_linear });
    });
  }

  onItemChange(value, name) {
    const data = { [name]: value };
    const { errors, save } = this.state;
    errors[name] = [];
    save.item = this.MODIFICADO;
    this.setState({ save, errors, ...data });
    this.patchItem({
      ...this.getValues(this.state),
      [name]: value
    });
  }

  onAlternativaChange(value, field, index) {
    const { alternativas, errors } = this.state;
    const alternativa = alternativas[index];
    alternativa[field] = value;

    const { save } = this.state;
    save[alternativa.id] = this.MODIFICADO;
    this.setState({ save });

    if (errors.alternativas && errors.alternativas[index]) {
      errors.alternativas[index][field] = [];
    }

    this.setState({ alternativas, errors });

    const debouncedPatchAlternativa = this.debouncedPatchAlternativa[index];
    // const atualizarDistratores = field === 'gabarito' && value;

    if (debouncedPatchAlternativa) {
      if (field === 'gabarito') {
        this.patchAlternativa(alternativa, true);
      } else {
        debouncedPatchAlternativa(alternativa);
      }
    }
  }

  onGradeLinearChange(value, name) {
    const { errors, save, grade_linear } = this.state;
    const data = {
      grade_linear: {
        ...grade_linear,
        [name]: value
      }
    };

    errors[name] = [];
    save.item = this.MODIFICADO;
    this.setState({ save, errors, ...data });
    this.patchItem({
      ...this.getValues(this.state),
      ...data
    });
  }

  onGradeLinearMultiplaChange(value, name) {
    const { errors, save, grade_linear } = this.state;

    let data = {};

    if (isEmpty(grade_linear[name])) {
      data = {
        grade_linear: {
          ...grade_linear,
          [name]: [value]
        }
      };
    } else {
      if (grade_linear[name].find((x) => x.position === value.position)) {
        grade_linear[name] = grade_linear[name].map((x) => {
          if (x.position === value.position) {
            return { position: x.position, value: value.value };
          } else {
            return x;
          }
        });
      } else {
        grade_linear[name] = [...grade_linear[name], value];
      }
      data = { grade_linear };
    }

    errors[name] = [];
    save.item = this.MODIFICADO;
    this.setState({ save, errors, ...data });
    this.patchItem({
      ...this.getValues(this.state),
      ...data
    });
  }

  onGradeLinearMultiplaExclude(name, position) {
    const { errors, save, grade_linear } = this.state;

    grade_linear[name] = grade_linear[name].filter(
      (x) => x.position !== position
    );

    const data = { grade_linear };

    errors[name] = [];
    save.item = this.MODIFICADO;
    this.setState({ save, errors, ...data });
    this.patchItem({
      ...this.getValues(this.state),
      ...data
    });
  }

  patchItem = debounce((data) => {
    const { save } = this.state;
    save.item = this.SALVANDO;
    this.setState({ save });
    axios.patch(`${API_HOST}/itens/item/${this.id}`, data).then(() => {
      const { save } = this.state;
      save.item = this.SALVO;
      this.setState({ save });
    });
  }, 1000);

  onSubmit(url, tipo) {
    axios
      .get(`${API_HOST}/itens/item/${this.id}/validate?form=conteudo`)
      .then((res) => {
        const { history } = this.props;
        if (res.data === 'EXCEEDED') {
          swal
            .fire({
              text: 'Este item ultrapassou o limite recomendado, caso deseje prosseguir mesmo assim, clique em "Confirmar"',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#45c0f5',
              cancelButtonColor: '#c8700a',
              confirmButtonText: 'Confirmar',
              cancelButtonText: 'Cancelar'
            })
            .then((result) => {
              if (result.isConfirmed) {
                history.push(`/itens/${this.id}/${url}`);
              }
            });
        } else {
          history.push(`/itens/${this.id}/${url}`);
        }
      })
      .catch((error) => {
        this.onValidateError(error);
      });
  }
  onValidateError(error) {
    const status = get(error, 'response.status');

    if (status === 400) {
      const errors = get(error, 'response.data');
      this.setState({ errors });
      this.renderErrorToast(errors, 'conteudo');
    }
  }

  formIsDisabled() {
    const { save } = this.state;
    return Object.keys(save).some(
      (key) => save[key] === this.SALVANDO || save[key] === this.MODIFICADO
    );
  }

  renderError(error) {
    return (
      <p key={error} className="text-danger">
        {error}
      </p>
    );
  }

  descerAlternativa(alternativa) {
    axios
      .patch(`${API_HOST}/itens/alternativa/${alternativa.id}`, {
        posicao: alternativa.posicao + 1
      })
      .then(this.fetchAlternativas);
  }

  subirAlternativa(alternativa) {
    axios
      .patch(`${API_HOST}/itens/alternativa/${alternativa.id}`, {
        posicao: alternativa.posicao - 1
      })
      .then(this.fetchAlternativas);
  }

  uploadArquivo(event) {
    const file = get(event, 'target.files.0');

    if (file) {
      if (file.type !== 'video/mp4') {
        toast.error('No momento, somente o formato .mp4 é suportado.');
        return;
      }

      this.setState({ uploading: true });

      const data = new FormData();
      data.append('file', file);
      axios
        .post(`${API_HOST}/itens/item/${this.id}/arquivos`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent) {
              this.setState({ progressEvent });
            }
          }
        })
        .then((response) => {
          const { arquivos } = this.state;
          this.setState({
            arquivos: [response.data, ...arquivos],
            uploading: false
          });
        })
        .catch((error) => {
          this.setState({ uploading: false });
          const status = get(error, 'response.status');
          let message =
            'Ocorreu um erro e não foi possível submeter o arquivo.';
          if (status === 400) {
            message = get(error, 'response.data.file.0') || message;
          }
          toast.error(message);
        });
    }
  }

  uploadArquivoAlternativa(event, i) {
    const { alternativas } = this.state;
    const alternativa = alternativas[i];

    const file = get(event, 'target.files.0');

    if (file) {
      if (file.type !== 'video/mp4') {
        toast.error('No momento, somente o formato .mp4 é suportado.');
        return;
      }

      this.setState({ [`uploading_${alternativa.id}`]: true });

      const data = new FormData();
      data.append('file', file);

      axios
        .post(`${API_HOST}/itens/alternativa/${alternativa.id}/arquivo`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent) {
              this.setState({
                [`progressEvent_${alternativa.id}`]: progressEvent
              });
            }
          }
        })
        .then((response) => {
          const { alternativas } = this.state;
          alternativas[i].arquivo = response.data;

          this.setState({
            alternativas,
            [`uploading_${alternativa.id}`]: false
          });
        })
        .catch((error) => {
          this.setState({ [`uploading_${alternativa.id}`]: false });

          const status = get(error, 'response.status');
          let message =
            'Ocorreu um erro e não foi possível submeter o arquivo.';

          if (status === 400) {
            message = get(error, 'response.data.file.0') || message;
          }

          toast.error(message);
        });
    }
  }

  removeArquivo(file) {
    axios
      .delete(`${API_HOST}/uploads/${file.id}`)
      .then(() => {
        const { arquivos } = this.state;
        this.setState({ arquivos: arquivos.filter((f) => f.id !== file.id) });
        toast.success('Arquivo removido com sucesso.');
      })
      .catch(() => {
        toast.error('Ocorreu um erro e não foi possível remover o arquivo');
      });
  }

  removeArquivoAlternativa(file, i) {
    axios
      .delete(`${API_HOST}/uploads/${file.id}`)
      .then(() => {
        const { alternativas } = this.state;
        alternativas[i].arquivo = null;
        this.setState({ alternativas });
        toast.success('Arquivo removido com sucesso.');
      })
      .catch(() => {
        toast.error('Ocorreu um erro e não foi possível remover o arquivo');
      });
  }

  removeAlternativa() {
    const { selectedAlternative } = this.state;
    this.setState({ modalConfirmAlternativeRemoval: false });
    axios
      .delete(`${API_HOST}/itens/alternativa/${selectedAlternative}`)
      .then(() => {
        this.setState({ selectedAlternative: null });
        this.fetchAlternativas();
      })
      .catch(() =>
        toast.error('Ocorreu um erro e não foi possível remover a alternativa')
      );
  }

  removeHTMLTags(text) {
    if (text) {
      var regex = /(<([^>]+)>)/gi;
      return text.replace(regex, '');
    }
    return '';
  }

  handleRemoveAlternativa(alternativa) {
    this.setState({
      modalConfirmAlternativeRemoval: true,
      selectedAlternative: alternativa.id
    });
  }

  closeModelConfirmAlternativaRemoval() {
    this.setState({
      modalConfirmAlternativeRemoval: false,
      selectedAlternative: null
    });
  }

  createAlternativa() {
    const { alternativas } = this.state;
    const proxima_posicao = alternativas.length;
    const params = {
      item: this.id,
      posicao: proxima_posicao
    };
    axios
      .post(`${API_HOST}/itens/alternativa`, params)
      .then(() => this.fetchAlternativas())
      .catch(() =>
        toast.error('Ocorreu um erro e não foi possível criar a alternativa')
      );
  }

  shouldDisplayJustificativa(alternativa) {
    const param = alternativa.gabarito
      ? 'justificativa_gabarito'
      : 'justificativa';
    const isEmpty =
      !alternativa.justificativa || alternativa.justificativa === '<p><br></p>';
    return !isEmpty || this.shouldDisplay(`alternativa.${param}`);
  }

  justificativaIsRequired(alternativa) {
    const param = alternativa.gabarito
      ? 'justificativa_gabarito'
      : 'justificativa';
    return this.isRequired(`alternativa.${param}`);
  }

  renderMultiplaEscolha(isDisabled) {
    const {
      alternativas,
      comando_resposta,
      errors,
      situacao_problema,
      save,
      arquivos,
      uploading,
      progressEvent,
      modalConfirmAlternativeRemoval
    } = this.state;

    return (
      <FormContainer
        title="Conteúdo"
        previous="referencias-bibliograficas"
        next="fonte"
        onClick={this.onSubmit}
      >
        <div className="col-md-12 mb-3">{this.renderSaveStatus(save.item)}</div>
        <div className="col-md-12 form-group">
          <label style={{ color: '#453166' }}>Situação problema</label>
          <RawInputSummernote
            disabled={isDisabled}
            value={situacao_problema}
            onChange={(event) => this.onItemChange(event, 'situacao_problema')}
          />
          {get(errors, 'situacao_problema', []).map(this.renderError)}
        </div>
        <div className="col-md-12 form-group required">
          <label
            style={{ color: '#453166' }}
            className={classnames({
              'text-danger': get(errors, 'comando_resposta', []).length > 0
            })}
          >
            Comando resposta
          </label>
          <RawInputSummernote
            disabled={isDisabled}
            value={comando_resposta}
            onChange={(event) => this.onItemChange(event, 'comando_resposta')}
          />
          {get(errors, 'comando_resposta', []).map(this.renderError)}
        </div>
        {this.state.videoInputShouldDisplay ? (
          <InputFile
            disabled={isDisabled}
            label="Vídeo"
            onChange={this.uploadArquivo}
            onDelete={this.removeArquivo}
            files={arquivos}
            uploading={uploading}
            progressEvent={progressEvent}
          />
        ) : null}
        <hr />
        <label style={{ color: '#453166' }} className="pt-3 pl-3">
          Alternativas
        </label>
        <br />
        {alternativas.map((alternativa, index) => (
          <div className="resposta" key={alternativa.id}>
            <div className="card">
              <div
                className={classnames('card-header bg-white no-overflow', {
                  'success-background': alternativa.gabarito,
                  'danger-background': !alternativa.gabarito
                })}
              >
                <div className="row">
                  <div className="col-3">
                    <p>{`Alternativa ${String.fromCharCode(
                      alternativa.posicao + 65
                    )}`}</p>
                  </div>
                  <div className="col-5">
                    <div
                      className="btn-group pull-right"
                      role="group"
                      aria-label="Selecionar"
                    >
                      <button
                        disabled={isDisabled}
                        className={classnames('btn', {
                          '': alternativa.gabarito
                        })}
                        style={{
                          backgroundColor: alternativa.gabarito ? 'green' : '',
                          color: alternativa.gabarito ? 'white' : ''
                        }}
                        onClick={() => this.onAlternativaChange(true, 'gabarito', index)}
                      >
                        <CheckCircleIcon style={{ color: alternativa.gabarito ? 'white' : 'green' }} />
                        Gabarito
                      </button>
                      <button
                        disabled={isDisabled}
                        className={classnames('btn', {
                          '': !alternativa.gabarito
                        })}
                        style={{
                          backgroundColor: !alternativa.gabarito ? 'red' : '',
                          color: !alternativa.gabarito ? 'white' : ''
                        }}
                        onClick={() => this.onAlternativaChange(false, 'gabarito', index)}
                      >
                        <HighlightOffIcon style={{ color: alternativa.gabarito ? 'red' : 'white' }}/>
                        Distrator
                      </button>
                    </div>
                  </div>
                  <div className="col-2">
                    <div
                      className="btn-group pull-right"
                      role="group"
                      aria-label="Options"
                    >
                      {index !== alternativas.length - 1 && (
                        <button
                          disabled={isDisabled}
                          className="btn btn-white"
                          onClick={() => this.descerAlternativa(alternativa)}
                        >
                          <i className="fas fa-arrow-down" />
                        </button>
                      )}
                      {index !== 0 && (
                        <button
                          disabled={isDisabled}
                          className="btn btn-white"
                          onClick={() => this.subirAlternativa(alternativa)}
                        >
                          <i className="fas fa-arrow-up" />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="col-md-1">
                    <button
                      disabled={isDisabled}
                      className="btn btn-default btn-nobackgorund"
                    >
                      {this.renderSaveStatus(
                        save[alternativa.id],
                        `status${index}`
                      )}
                    </button>
                  </div>
                  <div className="col-md-1">
                    <button
                      disabled={isDisabled}
                      className="btn btn-white"
                      onClick={() => this.handleRemoveAlternativa(alternativa)}
                    >
                      <i className="fas fa-times-circle" />
                    </button>
                  </div>
                </div>
              </div>
              <div
                style={{ borderTop: '0.5px solid #d6d6d6' }}
                className="card-body bg-white no-overflow"
              >
                {this.shouldDisplay('alternativa.descricao') && (
                  <div
                    className={classnames('col-md-12 form-group', {
                      required: this.isRequired('alternativa.descricao')
                    })}
                  >
                    <label
                      style={{ color: '#453166' }}
                      className={classnames({
                        required: this.isRequired('alternativa.descricao')
                      })}
                    >
                      Descrição
                    </label>
                    <RawInputSummernote
                      disabled={isDisabled}
                      required={this.justificativaIsRequired(alternativa)}
                      value={get(alternativas, `[${index}].descricao`)}
                      onChange={(value) =>
                        this.onAlternativaChange(value, 'descricao', index)
                      }
                    />
                    {get(errors, `alternativas.${index}.descricao`, []).map(
                      this.renderError
                    )}
                  </div>
                )}
                {this.shouldDisplayJustificativa(alternativa) && (
                  <div
                    className={classnames('col-md-12 form-group', {
                      required: this.justificativaIsRequired(alternativa),
                      'has-error': get(
                        errors,
                        `alternativas.${index}.justificativa.length`
                      )
                    })}
                  >
                    <label style={{ color: '#453166' }}>Justificativa</label>
                    <RawInputSummernote
                      disabled={isDisabled}
                      required={this.justificativaIsRequired(alternativa)}
                      value={get(alternativas, `[${index}].justificativa`)}
                      onChange={(value) =>
                        this.onAlternativaChange(value, 'justificativa', index)
                      }
                    />
                    {get(errors, `alternativas.${index}.justificativa`, []).map(
                      this.renderError
                    )}
                  </div>
                )}

                {this.shouldDisplay('alternativa.arquivo') &&
                  this.state.videoInputShouldDisplay && (
                    <InputFile
                      disabled={isDisabled}
                      label="Vídeo"
                      required={this.isRequired('alternativa.arquivo')}
                      onChange={(e) => this.uploadArquivoAlternativa(e, index)}
                      onDelete={(file) =>
                        this.removeArquivoAlternativa(file, index)
                      }
                      files={alternativa.arquivo ? [alternativa.arquivo] : []}
                      uploading={this.state[`uploading_${alternativa.id}`]}
                      progressEvent={
                        this.state[`progressEvent_${alternativa.id}`]
                      }
                    />
                  )}
              </div>
            </div>
          </div>
        ))}
        <div className="col-md-12">
          <button
            disabled={isDisabled}
            type="button"
            className="btn primary-button"
            onClick={() => this.createAlternativa(save.item)}
          >
            Adicionar Alternativa
          </button>
        </div>
        <Modal
          isOpen={modalConfirmAlternativeRemoval}
          toggle={() => this.closeModelConfirmAlternativaRemoval()}
        >
          <ModalHeader
            toggle={() => this.closeModelConfirmAlternativaRemoval()}
          >
            Tem certeza que deseja apagar a alternativa?
          </ModalHeader>
          <ModalBody>
            Ao apagar a alternativa todo o conteúdo dela será perdido.
          </ModalBody>
          <ModalFooter>
            <Button
              disabled={isDisabled}
              color="primary"
              onClick={() => this.removeAlternativa()}
            >
              Confirmar
            </Button>
            <Button
              disabled={isDisabled}
              color="secondary"
              onClick={() => this.closeModelConfirmAlternativaRemoval()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </FormContainer>
    );
  }
  handleValueChange(value) {
    this.setState({
      numero_respostas: value
    });
  }
  renderLacuna(isDisabled) {
    const {
      situacao_problema,
      expectativa_resposta,
      numero_respostas,
      orientacao_correcao,
      errors,
      comando_resposta,
      save,
      arquivos,
      uploading,
      progressEvent,
      max_char_number
    } = this.state;
    const setCheckboxTrue = () => {
      return this.setState({ checkboxSelected: !this.state.checkboxSelected });
    };
    return (
      <div>
        <FormContainer
          title="Conteúdo"
          previous="referencias-bibliograficas"
          next="fonte"
          onClick={this.onSubmit}
        >
          <div className="col-md-12 mb-3">
            {this.renderSaveStatus(save.item)}
          </div>
          <div className="col-md-12 form-group">
            <label style={{ color: '#453166' }}>Enunciado</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={situacao_problema || ''}
              onChange={(event) =>
                this.onItemChange(event, 'situacao_problema')
              }
            />
            <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <Button
                disabled={isDisabled}
                color="primary"
                onClick={() => {
                  this.setState({ isGraphOpen: !this.state.isGraphOpen });
                }}
              >
                GeoGebra
              </Button>
            </div>
            {this.state.isGraphOpen ? (
              <GeoGebra
                width="700"
                height="600"
                showMenuBar={true}
                showToolBar={true}
                showAlgebraInput={false}
              />
            ) : (
              <></>
            )}
          </div>
          <>
            <label>
              Número de lacunas:
              <input
                disabled={isDisabled}
                style={{ marginLeft: '1rem' }}
                type="number"
                max="9"
                min="1"
                value={
                  get(this.state, 'numero_respostas') ||
                  (1 && this.setState({ numero_respostas: 1 }))
                }
                onChange={(event) => {
                  this.onItemChange(event.target.value, 'numero_respostas');
                }}
              />
            </label>
          </>
          <div className="col-md-12 form-group mt-3">
            <label
              style={{ color: '#453166' }}
              className={classnames({
                'text-danger': get(errors, 'comando_resposta', []).length > 0
              })}
            >
              Comando resposta
            </label>
            <p>1) Cada pergunta deve ser colocada dentro de [].</p>
            <p>
              2) Cada lacuna deve ser declarada utilizando dois "_", dentro da
              pergunta e separada por espaços.{' '}
            </p>
            <p>Exemplo: [Esse é um módulo de __ .]</p>
            <p>3) Cada pergunta deve ser separada por ";" .</p>
            <p>
              Exemplo: [Esse é um módulo de __ .];[Nele nós escrevemos __ .]
            </p>
            <RawInputSummernote
              disabled={isDisabled}
              value={comando_resposta}
              onChange={(event) => this.onItemChange(event, 'comando_resposta')}
            />
            {get(errors, 'comando_resposta', []).map(this.renderError)}
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Expectativa de resposta</label>
            <p>1) Cada lacuna possuí apenas uma resposta correta.</p>
            <p>2) As respostas corretas devem ser colocadas entre [].</p>
            <p>Exemplo: [resposta_1]</p>
            <p>
              3) Os sinônimos, erros e equivalências aceitas para uma mesma
              respostada devem ser separadas por | dentro de [].
            </p>
            <p>Exemplo: [resposta_1|sinônimo_1|sinônimo_2]</p>
            <p>
              4) Quando exitem várias respostas corretas (caso em que existem
              várias lacunas), devemos separar cada resposta com ";".
            </p>
            <p>
              Exemplo:
              [resposta_1|sinônimo_1|sinônimo_2];[resposta_2|sinônimo_3|sinônimo_4];[resposta_3|sinônimo_5|sinônimo_6]
            </p>
            <RawInputSummernote
              disabled={isDisabled}
              value={expectativa_resposta || ''}
              onChange={(value) =>
                this.onItemChange(value, 'expectativa_resposta')
              }
            />
            <div className="pull-right mt-2">
              <h4 style={{ fontSize: '16px' }}>
                {this.removeHTMLTags(expectativa_resposta).length} caracteres
              </h4>
            </div>
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Orientação de correção</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={orientacao_correcao || ''}
              onChange={(value) =>
                this.onItemChange(value, 'orientacao_correcao')
              }
            />
          </div>
          <div className="mt-5">
            <div className="numeros row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group">
                <label style={{ color: '#453166' }}>Palavras</label>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Min.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'min_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'min_palavras')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Max.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'max_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'max_palavras')
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classnames(
                  'col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group',
                )}
              >
                <label
                  style={{ color: '#453166' }}
                  className="col-md-12 form-group"
                >
                  {'Caracteres por Resposta'}
                </label>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Min.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'min_caracteres') || ''}
                        onChange={(event) =>
                          this.onItemChange(
                            event.target.value,
                            'min_caracteres'
                          )
                        }
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex' }} className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Max.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        required={this.isRequired('item.max_caracteres')}
                        type="text"
                        className="form-control"
                        value={
                          get(this.state, 'max_char_number') ||
                            (get(this.state, 'max_caracteres') &&
                              parseFloat(get(this.state, 'max_caracteres')) > 0)
                            ? get(this.state, 'max_caracteres') /
                            numero_respostas -
                            2
                            : ''
                        }
                        onChange={(event) => {
                          this.onItemChange(
                            event.target.value,
                            'max_char_number'
                          );
                          this.onItemChange(
                            numero_respostas *
                            (2 + parseFloat(event.target.value)),
                            'max_caracteres'
                          );
                        }}
                      />
                    </div>
                    {this.isRequired('item.max_caracteres') && (
                      <div >
                        <span style={{ color: 'red', marginLeft: '6px' }}>*</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.checkboxSelected ? (
              <>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    onClick={() => setCheckboxTrue()}
                    style={{ marginRight: '5px' }}
                  />{' '}
                  Permitir que estudante faça upload de arquivos.
                </div>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    type="checkbox"
                    style={{ marginRight: '5px' }}
                    disabled={isDisabled}
                  />{' '}
                  Tornar obrigatório upload de arquivos
                </div>
              </>
            ) : (
              <div style={{ display: ' flex', flexDirection: 'row' }}>
                <input
                  disabled={isDisabled}
                  type="checkbox"
                  onClick={() => setCheckboxTrue()}
                  style={{ marginRight: '5px' }}
                />{' '}
                Permitir que estudante faça upload de arquivos.
              </div>
            )}
          </div>
        </FormContainer>
      </div>
    );
  }
  renderDiscursivo(tipo, isDisabled) {
    const {
      situacao_problema,
      expectativa_resposta,
      numero_respostas = 1,
      orientacao_correcao,
      errors,
      comando_resposta,
      save,
      arquivos,
      uploading,
      progressEvent,
      max_char_number
    } = this.state;
    const setCheckboxTrue = () => {
      return this.setState({ checkboxSelected: !this.state.checkboxSelected });
    };
    return (
      <div>
        <FormContainer
          title="Conteúdo"
          previous="referencias-bibliograficas"
          next="fonte"
          onClick={this.onSubmit}
        >
          <div className="col-md-12 mb-3">
            {this.renderSaveStatus(save.item)}
          </div>
          <div className="col-md-12 form-group">
            <label style={{ color: '#453166' }}>Enunciado</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={situacao_problema || ''}
              onChange={(event) =>
                this.onItemChange(event, 'situacao_problema')
              }
            />
            <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <Button
                disabled={isDisabled}
                color="primary"
                onClick={() => {
                  this.setState({ isGraphOpen: !this.state.isGraphOpen });
                }}
              >
                GeoGebra
              </Button>
            </div>
            {this.state.isGraphOpen ? (
              <GeoGebra
                width="700"
                height="600"
                showMenuBar={true}
                showToolBar={true}
                showAlgebraInput={false}
              />
            ) : (
              <></>
            )}
          </div>
          {tipo && tipo === TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
            <>
              <label>
                Número de respostas esperadas:
                <input
                  disabled={isDisabled}
                  style={{ marginLeft: '1rem' }}
                  type="number"
                  max="9"
                  min="1"
                  value={
                    get(this.state, 'numero_respostas') ||
                    (1 && this.setState({ numero_respostas: 1 }))
                  }
                  onChange={(event) => {
                    this.onItemChange(event.target.value, 'numero_respostas');
                  }}
                />
              </label>
            </>
          ) : (
            <></>
          )}
          <div className="col-md-12 form-group mt-3">
            <label
              style={{ color: '#453166' }}
              className={classnames({
                'text-danger': get(errors, 'comando_resposta', []).length > 0
              })}
            >
              Comando resposta
            </label>
            <RawInputSummernote
              disabled={isDisabled}
              value={comando_resposta}
              onChange={(event) => this.onItemChange(event, 'comando_resposta')}
            />
            {get(errors, 'comando_resposta', []).map(this.renderError)}
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Expectativa de resposta</label>
            {tipo && tipo === TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
              <>
                <p>As respostas corretas devem ser colocadas entre [].</p>
                <p>Exemplo: [resposta_1]</p>
                <p>
                  Os sinônimos, erros e equivalências aceitas para uma mesma
                  respostada devem ser separadas por | dentro de [].
                </p>
                <p>Exemplo: [resposta_1|sinônimo_1|sinônimo_2]</p>
                <p>
                  Quando exitem várias respostas corretas, devemos separar cada
                  resposta com ";".
                </p>
                <p>
                  Exemplo:
                  [resposta_1|sinônimo_1|sinônimo_2];[resposta_2|sinônimo_3|sinônimo_4];[resposta_3|sinônimo_5|sinônimo_6]
                </p>
              </>
            ) : (
              <>
                <p>As respostas corretas devem ser colocadas entre [].</p>
                <p>Exemplo: [resposta_1]</p>
                <p>
                  Os sinônimos, erros e equivalências aceitas para uma mesma
                  respostada devem ser separadas por | dentro de [].
                </p>
                <p>Exemplo: [resposta_1|sinônimo_1|sinônimo_2]</p>
                <p>
                  <strong>Atenção!</strong> A expectativa de resposta{' '}
                  <strong>NÃO</strong> poderá ser estilizada.
                </p>
              </>
            )}
            <RawInputSummernote
              disabled={isDisabled}
              value={expectativa_resposta || ''}
              onChange={(value) =>
                this.onItemChange(value, 'expectativa_resposta')
              }
            />
            <div className="pull-right mt-2">
              <h4 style={{ fontSize: '16px' }}>
                {this.removeHTMLTags(expectativa_resposta).length} caracteres
              </h4>
            </div>
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Orientação de correção</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={orientacao_correcao || ''}
              onChange={(value) =>
                this.onItemChange(value, 'orientacao_correcao')
              }
            />
          </div>
          <div className="mt-5">
            <div className="numeros row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group">
                <label style={{ color: '#453166' }}>Palavras</label>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Min.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'min_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'min_palavras')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Max.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'max_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'max_palavras')
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {tipo && tipo !== TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
                <div
                  className={classnames(
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group',
                  )}
                >
                  <label
                    style={{ color: '#453166' }}
                    className="col-md-12 form-group"
                  >
                    Caracteres
                  </label>
                  <>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Min.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'min_caracteres') || ''}
                            onChange={(event) =>
                              this.onItemChange(
                                event.target.value,
                                'min_caracteres'
                              )
                            }
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex" }} className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Max.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            required={this.isRequired('item.max_caracteres')}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'max_caracteres') || ''}
                            onChange={(event) => {
                              this.onItemChange(
                                event.target.value,
                                'max_caracteres'
                              );
                            }}
                          />
                        </div>
                        {this.isRequired('item.max_caracteres') && (
                          <div >
                            <span style={{ color: 'red', marginLeft: '6px' }}>*</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <div
                  className={classnames(
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group'
                  )}
                >
                  <label
                    style={{ color: '#453166' }}
                    className="col-md-12 form-group"
                  >
                    Caracteres por Resposta
                  </label>
                  <>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Min.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'min_caracteres') || ''}
                            onChange={(event) =>
                              this.onItemChange(
                                event.target.value,
                                'min_caracteres'
                              )
                            }
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex' }} className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Max.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            required={this.isRequired('item.max_caracteres')}
                            type="text"
                            className="form-control"
                            value={
                              get(this.state, 'max_char_number') ||
                                (get(this.state, 'max_caracteres') &&
                                  parseFloat(get(this.state, 'max_caracteres')) >
                                  0)
                                ? get(this.state, 'max_caracteres') /
                                numero_respostas -
                                2
                                : ''
                            }
                            onChange={(event) => {
                              this.onItemChange(
                                event.target.value,
                                'max_char_number'
                              );
                              this.onItemChange(
                                numero_respostas *
                                (2 + parseFloat(event.target.value)),
                                'max_caracteres'
                              );
                            }}
                          />
                        </div>
                        {this.isRequired('item.max_caracteres') && (
                          <>
                            <span style={{ color: 'red', marginLeft: '6px' }}>*</span>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.checkboxSelected ? (
              <>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    onClick={() => setCheckboxTrue()}
                    style={{ marginRight: '5px' }}
                  />{' '}
                  Permitir que estudante faça upload de arquivos.
                </div>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    style={{ marginRight: '5px' }}
                  />{' '}
                  Tornar obrigatório upload de arquivos
                </div>
              </>
            ) : (
              <div style={{ display: ' flex', flexDirection: 'row' }}>
                <input
                  disabled={isDisabled}
                  type="checkbox"
                  onClick={() => setCheckboxTrue()}
                  style={{ marginRight: '5px' }}
                />{' '}
                Permitir que estudante faça upload de arquivos.
              </div>
            )}
          </div>
        </FormContainer>
      </div>
    );
  }
  renderFlashCard(isDisabled) {
    const {
      situacao_problema,
      expectativa_resposta,
      orientacao_correcao,
      errors,
      comando_resposta,
      save,
      arquivos,
      uploading,
      progressEvent
    } = this.state;

    return (
      <div>
        <FormContainer
          title="Conteúdo"
          previous="referencias-bibliograficas"
          next="fonte"
        >
          <div className="col-md-12 mb-3">
            {this.renderSaveStatus(save.item)}
          </div>
          <div className="col-md-12 form-group">
            <label style={{ color: '#453166' }}>Cartão Resposta</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={situacao_problema || ''}
              onChange={(event) =>
                this.onItemChange(event, 'situacao_problema')
              }
            />
          </div>
          <div className="col-md-12 form-group mt-3">
            <label
              disabled={isDisabled}
              style={{ color: '#453166' }}
              className={classnames({
                'text-danger': get(errors, 'comando_resposta', []).length > 0
              })}
            >
              Resposta
            </label>
            <RawInputSummernote
              disabled={isDisabled}
              value={comando_resposta}
              onChange={(event) => this.onItemChange(event, 'comando_resposta')}
            />
            {get(errors, 'comando_resposta', []).map(this.renderError)}
          </div>
        </FormContainer>
      </div>
    );
  }
  renderPlurall(titulo, isDisabled) {
    const {
      situacao_problema,
      expectativa_resposta,
      orientacao_correcao,
      errors,
      comando_resposta,
      save,
      arquivos,
      uploading,
      progressEvent
    } = this.state;

    return (
      <div>
        <FormContainer
          title="Conteúdo"
          previous="referencias-bibliograficas"
          next="fonte"
        >
          <div className="col-md-12 mb-3">
            {this.renderSaveStatus(save.item)}
          </div>
          <div className="col-md-12 form-group">
            <label style={{ color: '#453166' }}>
              {!titulo ? 'Enunciado' : titulo}
            </label>
            <RawInputSummernote
              disabled={isDisabled}
              value={situacao_problema || ''}
              onChange={(event) =>
                this.onItemChange(event, 'situacao_problema')
              }
            />
          </div>
        </FormContainer>
      </div>
    );
  }

  renderEscalaLinear() {
    const { situacao_problema, errors, comando_resposta } = this.state;

    return (
      <FormContainer
        title="Conteúdo"
        previous="referencias-bibliograficas"
        next="fonte"
        onClick={this.onSubmit}
      >
        <div className="col-md-12 form-group">
          <label style={{ color: '#453166' }}>Situação problema</label>
          <RawInputSummernote
            value={situacao_problema}
            onChange={(event) => this.onItemChange(event, 'situacao_problema')}
          />
          {get(errors, 'situacao_problema', []).map(this.renderError)}
        </div>
        <div className="col-md-12 form-group">
          <label
            className={classnames({
              'text-danger': get(errors, 'comando_resposta', []).length > 0
            })}
          >
            Comando resposta
          </label>
          <RawInputSummernote
            value={comando_resposta}
            onChange={(event) => this.onItemChange(event, 'comando_resposta')}
          />
          {get(errors, 'comando_resposta', []).map(this.renderError)}
          <div className="mt-5">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <label style={{ color: '#453166' }}>Texto inicial</label>
                <div className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    value={get(this.state, 'grade_linear.texto_inicial') || ''}
                    onChange={(event) =>
                      this.onGradeLinearChange(
                        event.target.value,
                        'texto_inicial'
                      )
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <label style={{ color: '#453166' }}>Texto Final</label>
                <div className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    value={get(this.state, 'grade_linear.texto_final') || ''}
                    onChange={(event) =>
                      this.onGradeLinearChange(
                        event.target.value,
                        'texto_final'
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label className="sr-only" />
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <div className="input-group-text">Início</div>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={get(this.state, 'grade_linear.inicio') || ''}
                    onChange={(event) =>
                      this.onGradeLinearChange(event.target.value, 'inicio')
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label className="sr-only" />
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <div className="input-group-text">Intervalo</div>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={get(this.state, 'grade_linear.intervalo') || ''}
                    onChange={(event) =>
                      this.onGradeLinearChange(event.target.value, 'intervalo')
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label className="sr-only" />
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <div className="input-group-text">Fim</div>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={get(this.state, 'grade_linear.fim') || ''}
                    onChange={(event) =>
                      this.onGradeLinearChange(event.target.value, 'fim')
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <PreviewEscalaLinear
              textoInicial={this.state.grade_linear.texto_inicial}
              textoFinal={this.state.grade_linear.texto_final}
              inicio={this.state.grade_linear.inicio}
              fim={this.state.grade_linear.fim}
              intervalo={this.state.grade_linear.intervalo}
            />
          </div>
        </div>
      </FormContainer>
    );
  }

  renderEscalaLinearMultipla() {
    const { situacao_problema, errors, comando_resposta } = this.state;

    return (
      <FormContainer
        title="Conteúdo"
        previous="referencias-bibliograficas"
        next="fonte"
        onClick={this.onSubmit}
      >
        <div className="col-md-12 form-group">
          <label style={{ color: '#453166' }}>Situação problema</label>
          <RawInputSummernote
            value={situacao_problema}
            onChange={(event) => this.onItemChange(event, 'situacao_problema')}
          />
          {get(errors, 'situacao_problema', []).map(this.renderError)}
        </div>
        <div className="col-md-12 form-group">
          <label
            className={classnames({
              'text-danger': get(errors, 'comando_resposta', []).length > 0
            })}
          >
            Comando resposta
          </label>
          <RawInputSummernote
            value={comando_resposta}
            onChange={(event) => this.onItemChange(event, 'comando_resposta')}
          />
          {get(errors, 'comando_resposta', []).map(this.renderError)}
        </div>
        <div className="col-md-12 form-group">
          <GradeLinearMultipla
            onChangeItem={this.onGradeLinearMultiplaChange}
            onExcludeItem={this.onGradeLinearMultiplaExclude}
            values={get(this.state, 'grade_linear') || ''}
          />
        </div>
      </FormContainer>
    );
  }

  getRubricaValor = (e, id) => {
    this.setState({ valorRubrica: e.target.value })
    this.handleInputValor(id)
  }

  getRubricaDescricao = (e, id) => {
    this.setState({ descricaoRubrica: e.target.value })
    this.handleInputDescricao(id)
  }

  handleInputDescricao = debounce((id) => {
    const text = this.state.descricaoRubrica
    const payload = {
      rubrica_id: id,
      rubricaDescricao: text
    }

    axios.post(`${API_HOST}/itens/discursivo_rubrica/post_rubrica`, {
      payload
    })
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  }, 1000);

  handleInputValor = debounce((id) => {
    const text = this.state.valorRubrica
    const payload = {
      rubrica_id: id,
      rubricaValor: text
    }

    axios.post(`${API_HOST}/itens/discursivo_rubrica/post_rubrica`, {
      payload
    })
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  }, 1000);

  deleteRubrica = (e) => {
    axios.delete(`${API_HOST}/itens/discursivo_rubrica/${e}/delete_rubrica`)
      .then(() => {
        this.setState({ rubricas: [] })
        this.fetchRubricas()
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleAddRubrica = () => {
    const payload = {
      item_id: this.id,
      rubricaValor: null,
      rubricaDescricao: '',
      rubrica_id: null
    }

    axios
      .post(`${API_HOST}/itens/discursivo_rubrica/post_rubrica`, {
        payload
      })
      .then((response) => {
        axios.get(`${API_HOST}/itens/discursivo_rubrica/${this.id}/get_rubrica`)
          .then((response => {
            this.setState({ rubricas: response.data })
          }))
      })
      .catch((error) => {
        console.log(error);
      });
  };


  renderDiscursivoRubricas(tipo, isDisabled) {
    const {
      situacao_problema,
      expectativa_resposta,
      numero_respostas = 1,
      orientacao_correcao,
      errors,
      comando_resposta,
      save,
      arquivos,
      uploading,
      progressEvent,
      max_char_number,
      rubricas,
    } = this.state;
    const setCheckboxTrue = () => {
      return this.setState({ checkboxSelected: !this.state.checkboxSelected });
    };
    return (
      <div>
        <FormContainer
          title="Conteúdo"
          previous="referencias-bibliograficas"
          next="fonte"
          onClick={this.onSubmit}
        >
          <div className="col-md-12 mb-3">
            {this.renderSaveStatus(save.item)}
          </div>
          <div className="col-md-12 form-group">
            <label style={{ color: '#453166' }}>Enunciado</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={situacao_problema || ''}
              onChange={(event) =>
                this.onItemChange(event, 'situacao_problema')
              }
            />
            <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <Button
                disabled={isDisabled}
                color="primary"
                onClick={() => {
                  this.setState({ isGraphOpen: !this.state.isGraphOpen });
                }}
              >
                GeoGebra
              </Button>
            </div>
            {this.state.isGraphOpen ? (
              <GeoGebra
                width="700"
                height="600"
                showMenuBar={true}
                showToolBar={true}
                showAlgebraInput={false}
              />
            ) : (
              <></>
            )}
          </div>
          {tipo && tipo === TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
            <>
              <label>
                Número de respostas esperadas:
                <input
                  disabled={isDisabled}
                  style={{ marginLeft: '1rem' }}
                  type="number"
                  max="9"
                  min="1"
                  value={
                    get(this.state, 'numero_respostas') ||
                    (1 && this.setState({ numero_respostas: 1 }))
                  }
                  onChange={(event) => {
                    this.onItemChange(event.target.value, 'numero_respostas');
                  }}
                />
              </label>
            </>
          ) : (
            <></>
          )}
          <div className="col-md-12 form-group mt-3">
            <label
              style={{ color: '#453166' }}
              className={classnames({
                'text-danger': get(errors, 'comando_resposta', []).length > 0
              })}
            >
              Comando resposta
            </label>
            <RawInputSummernote
              disabled={isDisabled}
              value={comando_resposta}
              onChange={(event) => this.onItemChange(event, 'comando_resposta')}
            />
            {get(errors, 'comando_resposta', []).map(this.renderError)}
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Expectativa de resposta</label>
            {tipo && tipo === TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
              <>
                <p>As respostas corretas devem ser colocadas entre [].</p>
                <p>Exemplo: [resposta_1]</p>
                <p>
                  Os sinônimos, erros e equivalências aceitas para uma mesma
                  respostada devem ser separadas por | dentro de [].
                </p>
                <p>Exemplo: [resposta_1|sinônimo_1|sinônimo_2]</p>
                <p>
                  Quando exitem várias respostas corretas, devemos separar cada
                  resposta com ";".
                </p>
                <p>
                  Exemplo:
                  [resposta_1|sinônimo_1|sinônimo_2];[resposta_2|sinônimo_3|sinônimo_4];[resposta_3|sinônimo_5|sinônimo_6]
                </p>
              </>
            ) : (
              <>
                <p>As respostas corretas devem ser colocadas entre [].</p>
                <p>Exemplo: [resposta_1]</p>
                <p>
                  Os sinônimos, erros e equivalências aceitas para uma mesma
                  respostada devem ser separadas por | dentro de [].
                </p>
                <p>Exemplo: [resposta_1|sinônimo_1|sinônimo_2]</p>
                <p>
                  <strong>Atenção!</strong> A expectativa de resposta{' '}
                  <strong>NÃO</strong> poderá ser estilizada.
                </p>
              </>
            )}
            <RawInputSummernote
              disabled={isDisabled}
              value={expectativa_resposta || ''}
              onChange={(value) =>
                this.onItemChange(value, 'expectativa_resposta')
              }
            />
            <div className="pull-right mt-2">
              <h4 style={{ fontSize: '16px' }}>
                {this.removeHTMLTags(expectativa_resposta).length} caracteres
              </h4>
            </div>
          </div>
          <div className="col-md-12 form-group mt-3">
            <label style={{ color: '#453166' }}>Orientação de correção</label>
            <RawInputSummernote
              disabled={isDisabled}
              value={orientacao_correcao || ''}
              onChange={(value) =>
                this.onItemChange(value, 'orientacao_correcao')
              }
            />
          </div>
          <div className="mt-5">
            <div className="numeros row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group">
                <label style={{ color: '#453166' }}>Palavras</label>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Min.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'min_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'min_palavras')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <label className="sr-only" />
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <div className="input-group-text">Max.</div>
                      </div>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control"
                        value={get(this.state, 'max_palavras') || ''}
                        onChange={(event) =>
                          this.onItemChange(event.target.value, 'max_palavras')
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {tipo && tipo !== TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA ? (
                <div
                  className={classnames(
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group',
                  )}
                >
                  <label
                    style={{ color: '#453166' }}
                    className="col-md-12 form-group"
                  >
                    Caracteres
                  </label>
                  <>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Min.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'min_caracteres') || ''}
                            onChange={(event) =>
                              this.onItemChange(
                                event.target.value,
                                'min_caracteres'
                              )
                            }
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex" }} className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Max.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            required={this.isRequired('item.max_caracteres')}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'max_caracteres') || ''}
                            onChange={(event) => {
                              this.onItemChange(
                                event.target.value,
                                'max_caracteres'
                              );
                            }}
                          />
                        </div>
                        <>
                          {this.isRequired('item.max_caracteres') && (
                            <div >
                              <span style={{ color: 'red', marginLeft: '6px' }}>*</span>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <div
                  className={classnames(
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group',
                    { required: this.isRequired('item.max_caracteres') }
                  )}
                >
                  <label
                    style={{ color: '#453166' }}
                    className="col-md-12 form-group"
                  >
                    Caracteres por Resposta
                  </label>
                  <>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Min.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            type="text"
                            className="form-control"
                            value={get(this.state, 'min_caracteres') || ''}
                            onChange={(event) =>
                              this.onItemChange(
                                event.target.value,
                                'min_caracteres'
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label className="sr-only" />
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">Max.</div>
                          </div>
                          <input
                            disabled={isDisabled}
                            required={this.isRequired('item.max_caracteres')}
                            type="text"
                            className="form-control"
                            value={
                              get(this.state, 'max_char_number') ||
                                (get(this.state, 'max_caracteres') &&
                                  parseFloat(get(this.state, 'max_caracteres')) >
                                  0)
                                ? get(this.state, 'max_caracteres') /
                                numero_respostas -
                                2
                                : ''
                            }
                            onChange={(event) => {
                              this.onItemChange(
                                event.target.value,
                                'max_char_number'
                              );
                              this.onItemChange(
                                numero_respostas *
                                (2 + parseFloat(event.target.value)),
                                'max_caracteres'
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.checkboxSelected ? (
              <>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    onClick={() => setCheckboxTrue()}
                    style={{ marginRight: '5px' }}
                  />{' '}
                  Permitir que estudante faça upload de arquivos.
                </div>
                <div style={{ display: ' flex', flexDirection: 'row' }}>
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    style={{ marginRight: '5px' }}
                  />{' '}
                  Tornar obrigatório upload de arquivos
                </div>
              </>
            ) : (
              <div style={{ display: ' flex', flexDirection: 'row' }}>
                <input
                  disabled={isDisabled}
                  type="checkbox"
                  onClick={() => setCheckboxTrue()}
                  style={{ marginRight: '5px' }}
                />{' '}
                Permitir que estudante faça upload de arquivos.
              </div>
            )}
          </div>
          {rubricas.length > 0 ?
            <div style={{ paddingTop: '30px' }}>
              <>
                <div>
                  <span style={{ fontFamily: 'Quicksand', fontSize: '14px', fontWeight: '600' }}>Rubicas</span>
                </div>

                {rubricas.map((rubrica) => (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '17px' }}>
                      <div style={{ width: '75%' }}>
                        <span style={{ fontFamily: 'Quicksand', fontSize: '14px', fontWeight: '600', color: '#737373' }}>Descrição:</span>
                        <input
                          id={'desc-' + rubrica.id}
                          style={{ width: '100%' }}
                          type="text"
                          className="form-control"
                          defaultValue={rubrica.descricao}
                          // value={get(this.state, 'descricaoRubrica') || ''}
                          onChange={(e) => { this.getRubricaDescricao(e, rubrica.id) }}
                        />
                      </div>
                      <div style={{ width: '15%' }}>
                        <span style={{ fontFamily: 'Quicksand', fontSize: '14px', fontWeight: '600', color: '#737373' }}>Valor:</span>
                        <input
                          id={'value-' + rubrica.id}
                          type="text"
                          className="form-control"
                          defaultValue={rubrica.valor}
                          onChange={(e) => { this.getRubricaValor(e, rubrica.id) }}
                        />
                      </div>
                      <div style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'flex-end' }}>
                        <ClearIcon onClick={() => (this.deleteRubrica(rubrica.id))} style={{ marginBottom: '8px', color: 'red' }} />
                      </div>
                    </div>
                  </>
                ))}
                <div style={{ textAlign: 'center', width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                  <button
                    onClick={() => (this.handleAddRubrica())}
                    style={{ backgroundColor: '#863BFF', padding: '5px', borderRadius: '50%', border: 'none', cursor: 'pointer' }}
                  >
                    <AddIcon style={{ fontSize: '28px', color: '#fff' }} />
                  </button>
                </div>

              </>


            </div>


            :
            <div style={{ paddingTop: '20px' }}>
              <button
                style={{ fontFamily: 'Quicksand', fontSize: '18px', fontWeight: '700', textAlign: 'center', backgroundColor: '#863BFF', color: 'white', border: 'none', padding: '10px', borderRadius: "24px", cursor: 'pointer', outline: 'none' }}
                onClick={() => { this.handleAddRubrica() }}
              >
                <AddIcon style={{ marginRight: "7px" }} />Adicionar Rubica
              </button>
            </div>
          }

        </FormContainer>
      </div>
    );
  }
  render() {
    const { fetchingData, tipo } = this.state;
    const { isDisabled } = this.props;
    if (fetchingData) {
      return <Loading />;
    }

    if (
      [
        TIPOS_ITENS.MULTIPLA_ESCOLHA_UNICA,
        TIPOS_ITENS.MULTIPLA_ESCOLHA_MULTIPLA
      ].includes(tipo)
    ) {
      return this.renderMultiplaEscolha(isDisabled);
    }
    if (tipo === TIPOS_ITENS.DISCURSIVO_COM_RUBICAS) {
      return this.renderDiscursivoRubricas(tipo, isDisabled);
    }
    if (tipo === TIPOS_ITENS.DISCURSIVO) {
      return this.renderDiscursivo(tipo, isDisabled);
    }
    if (tipo === TIPOS_ITENS.TABELA_EDITAVEL) {
      return this.renderPlurall('Tabela', isDisabled);
    }
    if (tipo === TIPOS_ITENS.CONCEITO) {
      return this.renderPlurall('Conceito', isDisabled);
    }
    if (tipo === TIPOS_ITENS.IMAGEM) {
      return this.renderPlurall('Imagem', isDisabled);
    }
    if (tipo === TIPOS_ITENS.VIDEO) {
      return this.renderPlurall('Vídeo', isDisabled);
    }
    if (tipo === TIPOS_ITENS.FLASH_CARD) {
      return this.renderFlashCard(isDisabled);
    }
    if (tipo === TIPOS_ITENS.DISCURSIVO_RESPOSTA_MULTIPLA) {
      return this.renderDiscursivo(tipo, isDisabled);
    }
    if (tipo === TIPOS_ITENS.ESCALA_LINEAR_UNICA) {
      return this.renderEscalaLinear();
    }

    if (tipo === TIPOS_ITENS.ESCALA_LINEAR_MULTIPLA) {
      return this.renderEscalaLinearMultipla();
    }
    if (tipo === TIPOS_ITENS.LACUNA) {
      return this.renderLacuna(isDisabled);
    }

    return (
      <p>
        Por favor, antes de prosseguir, <Link to="dados">clique aqui</Link> para
        definir um tipo de objeto de aprendizado.
      </p>
    );
  }
}

export default withRouter(Conteudo);
